import { AppState } from "@pmis3/data-access";
import { VesselState, VesselStateStatus } from "../reducer/vessel.reducer";
import { createSelector } from "@ngrx/store";

export const vesselState = (state: AppState) => state.vesselState;

// export const selectVessels = createSelector(
//     vesselState,
//     (state: VesselState) => {
//         console.log("state: ", state)
//         return state.status === VesselStateStatus.SUCCESS ? state.vessels : [];
//     }
// )

export const selectVesselStateStatus = createSelector(
  vesselState,
  (state: VesselState) => state.status
)

// export const selectVesselOrientation = createSelector(
//   vesselState,
//   (state: VesselState) => state.vesselOrientations
// )